import {Component, Input, OnInit} from '@angular/core';
import {AbstractControl, FormBuilder, FormGroup, Validators} from '@angular/forms';
import {CustomValidator} from '../../../../services/custom-validator';
import {BsModalRef} from 'ngx-bootstrap/modal';
import {Subject} from 'rxjs';

@Component({
  selector: 'app-edit-queue-overflow-modal',
  templateUrl: './edit-queue-overflow-modal.component.html',
  styleUrls: ['./edit-queue-overflow-modal.component.css']
})
export class EditQueueOverflowModalComponent implements OnInit {

  @Input() modalTitle: string;
  objInitialState: any;
  overflowForm: FormGroup;
  oldOverflowConfig;
  itemSaved: Subject<any> = new Subject();
  availableConfigs;
  existingOrders;
  customInteractionQueueId;

  get formData() { return this.overflowForm.controls; }

  get orderError() {
    return this.existingOrders.filter(f => f == parseFloat(this.formData.order.value)).length > 0;
  }

  constructor(private formBuilder: FormBuilder, private bsModalRef: BsModalRef) { }

  ngOnInit() {
    this.createForm();
    if (this.objInitialState) {
      this.availableConfigs = this.objInitialState.availableConfig;
      if (this.objInitialState.overflow) {
        this.oldOverflowConfig = this.objInitialState.overflow;
        this.loadContent(this.objInitialState.overflow);
        this.customInteractionQueueId = this.oldOverflowConfig.customInteractionQueueConfigId;
      }
      if (this.objInitialState.customInteractionQueueConfigId) {
        this.customInteractionQueueId = this.objInitialState.customInteractionQueueConfigId;
      }

      if (this.objInitialState.existingOrders) {
        this.existingOrders = this.objInitialState.existingOrders;
      }
    }
  }

  loadContent(item) {
    this.overflowForm.patchValue({
      overflowCustomInteractionQueueConfigId: item.overflowCustomInteractionQueueConfigId,
      order: item.order
    });
  }

  createForm() {
    this.overflowForm = this.formBuilder.group({
      overflowCustomInteractionQueueConfigId: [0, this.validateSelectedQueue],
      order: [1, [ Validators.min(1), Validators.max(2147483647), CustomValidator.numeric ]]
    });
  }

  onClickOk() {
    let raw = this.overflowForm.getRawValue();
    raw.customInteractionQueueConfigId = this.customInteractionQueueId;
    raw.overflowCustomInteractionQueueConfigName =
      this.availableConfigs.filter(f => f.id == raw.overflowCustomInteractionQueueConfigId)[0].name;
    let response = {oldOverflow: this.oldOverflowConfig, newOverflow: raw};

    this.itemSaved.next(response);
    this.bsModalRef.hide();
  }

  onClose() {
    this.bsModalRef.hide();
  }

  validateSelectedQueue(control: AbstractControl) {
    if (control.value == 0 || control.value == undefined) {
      return {'requiredQueue' : true}
    }
    return null;
  }
}
